/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmailScheduleControllerCreateRequest { 
    /**
     * Correo personalizado, mismo formato que POST /emails (customSubject, customHtmlTemplate, attachments, recipients)
     */
    email: object;
    /**
     * Fechas de envío en ISO 8601; máximo 30, todas en el futuro
     */
    runAt: Array<string>;
}

